class WorkshopForm {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(".js-ws-name").text(this.getParam('title'));
    $("[name='ワークショップ名']").attr('value', this.getParam('title'));
    $(".js-date").text(this.getParam('date'));
    $("[name='開催日']").attr('value', this.getParam('date'));
    $(".js-price").text(this.getParam('price'));
    $("[name='料金']").attr('value', this.getParam('price'));
    $(".js-remarks").text(this.getParam('remarks'));
    $("[name='備考']").attr('value', this.getParam('remarks'));
  }
  getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
}
